(function (t) {
// ar
t.add("label_previous", "\u0627\u0644\u0633\u0627\u0628\u0642", "KnpPaginatorBundle", "ar");
t.add("label_next", "\u0627\u0644\u062a\u0627\u0644\u064a", "KnpPaginatorBundle", "ar");
})(Translator);
